import React from 'react'

const AboutLeach = () => {
	return (
		<p>
			A Brooklyn-based singer/songwriter with a penchant for disarming
			melodies and hypnotic electronic arrangements, Stuart Leach’s
			earnest lyricism, aching falsetto, and sonic orchestration give his
			music an unorthodox twist in a genre that sometimes sacrifices
			intimacy at the altar of cool.
			<p>
				Leach was born in 1993 in Dallas, Texas, attending an all-boys
				Catholic school where everyone was addressed by their last
				names. He began writing and performing piano pieces as early as
				age 11, eventually releasing them as 2011’s The Diving Bell. By
				the end of middle school, he was performing around the metroplex
				in the violin driven pop quartet Seastroke, who by their junior
				year of high school had opened for their idols Maps and Atlases
				and been featured on Coldplay's homepage.
			</p>
			<p>
				By 2012 at Bard College in upstate New York, Leach had turned
				his solo career towards electronic music, which lent itself to
				being quietly recorded in a dorm-room. After an initial creative
				drought, a broken engagement left Leach with plenty to write
				about. He processed this grief in 2014’s Roman Candles,
				featuring classmate Soubrette's voice on the eponymous track.
				"Little Taste of Heaven" would achieve viral fame years later,
				spreading Leach’s music to a global audience.
			</p>
			<p>
				{' '}
				His recently released single Will We Just Stay Alive explores
				the tension between aloneness and solidarity that the pandemic
				brought about.
			</p>
		</p>
	)
}

export default AboutLeach
